import { render, staticRenderFns } from "./IconKlimaat.vue?vue&type=template&id=60c1a6e1"
import script from "./IconKlimaat.vue?vue&type=script&lang=ts"
export * from "./IconKlimaat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports